import { bookVariantForTemplate } from "@lifescapsule/contracts";

/**
 * Books a buyer makes through the guided steps (owner decision D11, 2026-10-15; open to buyers
 * 2026-10-16): the Bedtime picture book, and My Story, Our Story, the Family Cookbook and the
 * Comic. The guided page hands any other book to the studio.
 */
export function opensGuided(book: {
  workflowKind?: string;
  templateId?: string;
  template?: { id?: string };
}) {
  const templateId = book.templateId ?? book.template?.id;
  return (
    book.workflowKind === "PICTURE_BOOK" ||
    (typeof templateId === "string" && bookVariantForTemplate(templateId) !== null)
  );
}
